const styles = {
  container: {
    maxWidth: 500,
    margin: '0px auto',
    padding: 20,
    borderRadius: 10,
    boxShadow: '0 0 12px rgba(0,0,0,0.1)',
    fontFamily: 'Arial, sans-serif',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  button: {
    padding: 12,
    backgroundColor: '#2563eb',
    color: 'white',
    border: 'none',
    borderRadius: 5,
    cursor: 'pointer',
  },
  disclaimer: {
    marginTop: 20,
    fontSize: '0.7rem',
    color: '#555',
    fontStyle: 'italic',
  },
  note: {
  fontSize: '0.7rem',
  color: '#666',
  fontStyle: 'italic',
  marginBottom: 10,
},
};

export default styles;